import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import { Component } from '@wordpress/element';
import PropTypes from 'prop-types';
import { TextControl as BaseComponent, withFocusOutside } from '@wordpress/components';
/**
 * An input field use for text inputs in forms.
 */

var TextControl = withFocusOutside(
/*#__PURE__*/
function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
    _this.state = {
      isFocused: false
    };
    return _this;
  }

  _createClass(_class, [{
    key: "handleFocusOutside",
    value: function handleFocusOutside() {
      this.setState({
        isFocused: false
      });
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick(event, onClick) {
      this.setState({
        isFocused: true
      });

      if (typeof onClick === 'function') {
        onClick(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isFocused = this.state.isFocused;

      var _this$props = this.props,
          className = _this$props.className,
          _onClick = _this$props.onClick,
          otherProps = _objectWithoutProperties(_this$props, ["className", "onClick"]);

      var label = otherProps.label,
          value = otherProps.value,
          disabled = otherProps.disabled;
      var isEmpty = '' === value;
      var isActive = isFocused && !disabled;
      return createElement(BaseComponent, _extends({
        className: classnames('muriel-component', 'muriel-input-text', className, {
          disabled: disabled,
          empty: isEmpty,
          active: isActive,
          'with-value': !isEmpty
        }),
        placeholder: label,
        onClick: function onClick(event) {
          return _this2.handleOnClick(event, _onClick);
        },
        onFocus: function onFocus() {
          return _this2.setState({
            isFocused: true
          });
        }
      }, otherProps));
    }
  }]);

  return _class;
}(Component));
TextControl.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * Disables the field.
   */
  disabled: PropTypes.bool,

  /**
   * Input label used as a placeholder.
   */
  label: PropTypes.string,

  /**
   * On click handler called when the component is clicked, passed the click event.
   */
  onClick: PropTypes.func,

  /**
   * The value of the input field.
   */
  value: PropTypes.string
};
export default TextControl;
//# sourceMappingURL=index.js.map